// extracted by mini-css-extract-plugin
export default {"shimmer":"Modal_shimmer__D6kla","dark_shimmer":"Modal_dark_shimmer__FqANW","modal":"Modal_modal__qajG1","close_btn":"Modal_close_btn__KeJu0","cancel_btn":"Modal_cancel_btn__0t0GD"};